import { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import "./EditarProducto.css";
const API = process.env.REACT_APP_API_URL;


export default function EditarProducto() {
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const [categorias, setCategorias] = useState([]);
  const [producto, setProducto] = useState({
    nombre: "",
    descripcion: "",
    precio: "",
    precioAnterior:"",
    stock: "",
    marca: "",
    sku: "",
    categoriaId: "",
    categoriaNombre: ""
  });
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);


  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch( API + "/user/refresh", {
         method:"POST",
          credentials: "include"
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        window.location.reload();
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };

  const [categoria, setCategoria] = useState({
    id: "",
    nombre: "",
    descripcion: ""
  });

  const traerProducto = async () => {
    try {
      const res = await fetch(`${API}/productos/getProducto/${id}`, {
      });
      const data = await res.json();
      const p = data.datos;

      setProducto({
        id:p.id || "",
        nombre: p.nombre || "",
        descripcion: p.descripcion || "",
        precio: p.precio || "",
        precioAnterior:p.precioAnterior || "",
        stock: p.stock || "",
        marca: p.marca || "",
        sku: p.sku || "",
        categoriaId: p.categoriaId || "",
        categoriaNombre: p.categoriaDTO?.nombre || "Sin categoría"
      });
    } catch (err) {
      setError("No se pudo cargar la información del producto.");
    }
  };

  const traerCategorias = async () => {
    try { 
      const res = await fetch( API + "/categorias/traerCategorias" , {
      });
      const data = await res.json();
      setCategorias(data.datos || []);
    } catch (err) {
      console.error("Error cargando categorías", err);
    }
  };

  useEffect(() => {
    traerProducto();
    traerCategorias();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProducto((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);

    const payload = {
      idProducto: Number(id),
      ...producto,
      precio: Number(producto.precio),
      stock: Number(producto.stock),
      categoriaId: Number(producto.categoriaId)
    };

    try {
      const res = await fetch( API + "/productos/ActualizarProducto", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "true"
        },
        body: JSON.stringify(payload)
      });


      if(res.status === 403 && await renovarToken())return;

      let data = await res.json()

      if (res.ok) {
        alert("Producto actualizado correctamente ✅");
        navigate("/")
      } else {
        alert("Error al actualizar el producto ❌");
      }
    } catch {
      alert("Error de conexión con el servidor");
    } finally {
      setCargando(false);
    }
  };

  if (error) return <div className="error-container">{error}</div>;

  return (
    <div className="edit-container">
      <div className="card">
        <header className="card-header">
          <h1>Editar Producto</h1>
          <p>Actualiza los detalles técnicos y de inventario</p>
        </header>

        <form onSubmit={handleSubmit} className="product-form">
          <div className="input-grid">
            <div className="form-group">
              <label htmlFor="nombre">Nombre del Producto</label>
              <input
                id="nombre"
                name="nombre"
                type="text"
                value={producto.nombre}
                onChange={handleChange}
                required
                placeholder="Ej. Laptop Pro 15"
              />
            </div>

            <div className="form-group">
              <label htmlFor="categoriaId">Categoría Actual: <span className="badge">{producto.categoriaNombre}</span></label>
              <select
                id="categoriaId"
                name="categoriaId"
                value={producto.categoriaId}
                onChange={handleChange}
                required
              >
                <option value="">Cambiar categoría...</option>
                {categorias.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="precio">Precio ($)</label>
              <input
                id="precio"
                name="precio"
                type="number"
                step="0.01"
                value={producto.precio}
                onChange={handleChange}
                required
              />
            </div>


            <div className="form-group">
              <label htmlFor="precioAnterior">Precio Anterior ($)</label>
              <input
                id="precioAnterior"
                name="precioAnterior"
                type="number"
                step="0.01"
                value={producto.precioAnterior}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="stock">Stock Disponible</label>
              <input
                id="stock"
                name="stock"
                type="number"
                value={producto.stock}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="marca">Marca</label>
              <input
                id="marca"
                name="marca"
                type="text"
                value={producto.marca}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="sku">SKU / Código</label>
              <input
                id="sku"
                name="sku"
                type="text"
                value={producto.sku}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="descripcion">Descripción</label>
            <textarea
              id="descripcion"
              name="descripcion"
              rows="4"
              value={producto.descripcion}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-actions">
            <button 
                type="button" 
                className="btn-secondary" 
                onClick={() => navigate(-1)}
            >
              Cancelar
            </button>
            <button 
                type="submit" 
                className="btn-primary" 
                disabled={cargando}
            >
              {cargando ? "Guardando..." : "Guardar Cambios"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}